import PmaxCampaignWizard from '@/components/google-ads/performance-max/PmaxCampaignWizard';
import { LOCAL_OBJECTIVE } from './localObjective';

/** NEW LOCAL STORE VISITS CAMPAIGN — /google-ads/local/create/campaign */
export default function LocalCampaignWizard() {
  return <PmaxCampaignWizard objective={LOCAL_OBJECTIVE} />;
}
